import { atom } from 'jotai';
import { allSearchResultsAtom } from 'packages/omnitag/state';

/** @returns an SWRResponse for the query's filtered search results, where already-sent items are filtered out,
 * if 'Hide Sent Items' filter is enabled */
export const filteredSearchResultsSelector = atom((get) => {
  const searchResults = get(allSearchResultsAtom);

  if (!searchResults || searchResults.isValidating || !searchResults.data)
    return searchResults;

  const allResults = searchResults.data.imageMetadata;

  return { ...searchResults, data: allResults };
});

export const requestIDAtom = atom<string | null>(null);
